import { Action, createAction } from "@ngrx/store";
import { Address, StateUtils, USER_ADDRESSES } from '@spartacus/core';


export const LOAD_USER_ADDRESSES = '[User] Load User Addresses By Zone';
export const LOAD_USER_ADDRESSES_FAIL = '[User] Load User Addresses By Zone Fail';
export const LOAD_USER_ADDRESSES_SUCCESS = '[User] Load User Addresses By Zone Success';

export const UPDATE_USER_ADDRESS = '[User] Update User Address By Zone';
export const UPDATE_USER_ADDRESS_FAIL = '[User] Update User Address By Zone Fail';
export const UPDATE_USER_ADDRESS_SUCCESS = '[User] Update User Address By Zone Success';

export const UPDATE_USER_ADDRESS_DESTROYED = createAction('[User] Finished Update User Address By Zone Success');

export const CLEAR_ADDRESSES = '[User] Clear Addresses';

export class LoadUserAddresses extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_USER_ADDRESSES;
  constructor(public payload: {
    userId: string,
    zone?: string
  }) {
    super(USER_ADDRESSES);
  }
}

export class LoadUserAddressesFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_USER_ADDRESSES_FAIL;
  constructor(public payload: any) {
    super(USER_ADDRESSES, payload);
  }
}

export class LoadUserAddressesSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_USER_ADDRESSES_SUCCESS;
  constructor(public payload: { addresses: Address[], zone?: string }) {
    super(USER_ADDRESSES);
  }
}


// Updating address actions
export class UpdateUserAddress extends StateUtils.LoaderLoadAction {
  readonly type = UPDATE_USER_ADDRESS;
  constructor(
    public payload: { userId: string; addressId: string; address: Address, zone: string }
  ) {
    super(USER_ADDRESSES);
  }
}

export class UpdateUserAddressFail extends StateUtils.LoaderFailAction {
  readonly type = UPDATE_USER_ADDRESS_FAIL;
  constructor(public payload: any) {
    super(USER_ADDRESSES, payload);
  }
}

export class UpdateUserAddressSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = UPDATE_USER_ADDRESS_SUCCESS;
  constructor(public payload: any) {
    super(USER_ADDRESSES);
  }
}

export class ClearAddresses implements Action {
  readonly type = CLEAR_ADDRESSES;
  constructor() {}
}


// action types
export type CustomUserAddressesAction =
  | LoadUserAddresses
  | LoadUserAddressesFail
  | LoadUserAddressesSuccess
  | UpdateUserAddress
  | UpdateUserAddressFail
  | UpdateUserAddressSuccess
  | ClearAddresses;
